module.exports = __webpack_public_path__ + "img/ts_2025_as.8f51e555.jpg";